
/**
 * At this point, the only routes we do not fully-configure in here are those
 * routes that require a URL parameter.  For example: The Baseline Task List
 * page has a URL of /admin/baseline-task-list/:baseline-id?, so you do not see
 * it here.  We just make use of the Routes.Admin beginning portion of the path
 * and hard-code the rest of the route template string when we need it.
 */
export const Routes = {
    Root: '/',
    Admin: '/admin',
    AdminHome: '/admin/home',
    BaselineTaskList: '/admin/baseline-task-list',    
    CrossBaselineSearch: '/admin/cross-baseline-search',
    CrossBaselineTaskLinkSearch: '/admin/cross-baseline-task-link-search',
    CrossSubscriptionSearch: '/admin/users',
    ProjectManagerDashboard: '/admin/pm-dashboard',
    NewProjectManagerDashboard: '/admin/project-dashboard',
    Dashboard: '/dashboard',
    DashboardEhAdmin:'/dashboard/ehadmin',
    DashboardLocation: '/dashboard/location',
    DashboardLocationFinancials: '/dashboard/location/financials-spreadsheet',
    DashboardCorporate: '/dashboard/corporate',
    Overview: '/overview',
    ManageCorporateViews: '/dashboard/manage-views',
    Forbidden: '/forbidden',
    ForgotPassword: "/Forgot-Password",
    ForgotUserName: "/Forgot-Username",
    LoginPage: '/login',
    LogoutPage: '/logout',
    FreeTrialSignUp: '/FreeTrialSignUp',
    Profile: '/profile',
    ProfileUser: '/profile/user',
    ProfileNotifications: '/profile/notifications',
    Reports: '/reports',
    ResetPassword: "/reset-password",
    SignUp: "/sign-up",
    SsoErrorPage: "/sso-error",
    ScheduleReport: '/schedule-report',
    StyleGuide: "/Style-Guide",
    Support: '/support',
    Tasks: '/tasks',
    ManageTaskViews: '/tasks/manage-views',
    ToolTips: '/tooltips',
    WebAssets: '/webassets',
    MyWorkspace: '/my-workspace',
    ReportsPage: '/reports-page',
    NewProjectWizard: '/new-project',
    External: {
        TaskCompletion: '/external/task-completion'
    },
    PchNotYet: '/pch-not-yet'
}

export default Routes;